import { toJS } from 'mobx'

export default {
  attrNameChange (EditContext: any, FIELD_NAME: string, data: any) {
    const { activeTable, activeTableData } = EditContext.editPageTable
    const copyDataSource = toJS(activeTableData.dataSource)
    const copyRecord = copyDataSource.find((item: any) => item.ID === data.config.__RECORD__.ID)
    const selected = data.payload.find((item: any) => item.ID === data.value)
    Object.assign(copyRecord, { 'Nav_EquipmentTypeAttr.CODE': selected.CODE })
    activeTable.setDataSource(copyDataSource)
  },
}